export default __webpack_public_path__ + "static/media/sign-in-logo.e6c062a1.png";